import React, { forwardRef } from 'react';

import { Box, type BoxProps } from '@atlaskit/primitives';

export interface TRProps extends BoxProps<'tr'> {
	/**
	 * If the row has programatic selection applied.
	 */
	isSelected?: boolean;
}

/**
 * __Row__
 *
 * A row primitive.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */
export const TR = forwardRef<HTMLTableRowElement, TRProps>(({ isSelected, ...props }, ref) => {
	return <Box as="tr" tabIndex={-1} aria-selected={isSelected} ref={ref} {...props} />;
});
